import { Temporal } from "@js-temporal/polyfill"
import { CoordinatorService } from "./coordinator.service"

export class LogItem {
    datetime: Temporal.ZonedDateTime
    type: string
    action: string
    payload: any

    constructor(private coords: CoordinatorService, params: any) {
        this.datetime = this.coords.utils$.zonedDateTimeFromNumber(
            Math.ceil(params.timestamp / 1000))
        this.type = params.type
        this.action = params.action
        this.payload = params.payload
    }


    get dateTimeText() {
        return this.coords.utils$.citeDate(this.datetime, {
            noFormat: true,
            withTime: true,
            showSeconds: true,
        })
    }

    hasItem(itmId: string | undefined) {
        if (!itmId) return false

        if (this.action === "change") {
            if (this._inList(itmId)) return true
        }
        if (this.action === "binary-select") {
            if (this._inBinarySelect(itmId)) return true
        }
        return false
    }

    private _inBinarySelect(itmId: string) {
        const onDct = this.payload?.on || {}
        const offDct = this.payload?.off || {}
        for (const key of Object.keys(onDct)) {
            if (key === itmId) return true
        }
        for (const key of Object.keys(offDct)) {
            if (key === itmId) return true
        }
        return false
    }

    private _binaryStorageLogBody(itmId: string) {
        const bt = this.coords.binaryTree$
            .getTree(this.payload.binaryTreeId)
        if (!bt) return `${this.coords.text("binaryTreeNotFound")}`
        const ndMap = bt.nodeMap
        const onLs: string[] = (this.payload?.on[itmId] as string[] || [])
            .map(nId => ndMap.get(nId)?.title)
            .filter(x => x) as string[]
        const offLs: string[] = (this.payload?.off[itmId] as string[] || [])
            .map(nId => ndMap.get(nId)?.title)
            .filter(x => x) as string[]

        const ls: string[] = []
        ls.push(`${this.coords.text(bt.type!)} - ${bt.title}`)
        if (onLs.length)
            ls.push(`${this.coords.text("on")} ${onLs.join(", ")}`)
        if (offLs.length)
            ls.push(`${this.coords.text("off")} ${offLs.join(", ")}`)
        return ls.join("\n")
        // ${onLs.join(", ")} ${this.coords.text("on")} ${offLs.join(", ")} 
        //     ${this.coords.text("off")}
        // `
    }

    private _inList(itmId: string) {
        if (this.payload.add?.includes(itmId)) return "add"
        if (this.payload.remove?.includes(itmId)) return "remove"
        if (this.payload.change?.includes(itmId)) return "change"
        return undefined
    }

    private _datasetItemLogBody(itmId: string) {
        switch (this._inList(itmId)) {
            case "add":
                return `${this.coords.text("itemAddedToCollection")}`
            case "remove":
                return `${this.coords.text("itemRemovedFromCollection")}`
            case "change":
                return `${this.coords.text("itemWasEdited")}`
            default: return ""
        }
    }


    private _viewItemLogBody(itmId: string) {
        const v = this.coords.view$
            .get(this.payload.id)
        const t = this.payload.title
        const actionText = this.coords.text(`subset-${this._inList(itmId)}`)

        if (!v)
            return `${actionText} ${this.coords.text("fromFormerSubset")} ${t}`
        let body = `${actionText} ${v.title}`

        if (v.title !== t)
            body += ` [ ${this.coords.text("was")} ${t}]`
        return body

    }


    get activeXitemLogBody() {
        const itmId = this.coords.resultList$.activeItem?.id
        if (!itmId) return ""
        switch (this.type) {
            case "dataset":
                return this._datasetItemLogBody(itmId)
            case "view":
                return this._viewItemLogBody(itmId)
            case "binary-storage":
                return this._binaryStorageLogBody(itmId)
            default:
                console.log("??????????", this)
        }

        return this.coords.resultList$.activeItem?.id
    }

    
    get activeBody() {
        switch (this.coords.stage$.current.tag) {
            case "collection":
                return this.activeXitemLogBody
            case "project":
                return {
                    type: this.type,
                    action: this.action,
                    payload: this.payload
                }
        }
        return "???LOG-BODY???"

    }
}
